import API from "utils/API";

export const getChannels = (data) => {
  return API.get(`/channel/channel/`);
};
